import React, { useRef } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import './Carousel-Social-Component-Preview.scss';
import { handleSlider } from '../../../../utils/UiBuilderUtils';

const CarouselSocialComponentPreview = (props) => {
  const { config } = props;
  const ref = useRef(null);
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
  };
  if (ref?.current) {
    handleSlider(config, ref);
  }
  // const onClickViewAll = () => {
  //  might need
  //   redirect call to link ie: instagram
  // }

  return (
    <div className='carousal-social'>
      {config?.slides?.length && (
        <div>
          <div className='preview-title'>{config?.titleH2 ? config?.titleH2 : 'H2 Title'}</div>
          <div
            className='carousal-social-box'
            style={{
              backgroundColor: config?.backgroundColor || '#8f8f8f',
              height: '90px',
            }}
          >
            <Carousel
              ref={ref}
              responsive={responsive}
              autoPlay={true}
              infinite={true}
              arrows={false}
              className='no_background'
            >
              {config.slides.map((slide, key) => (
                <div className='h-100' key={key}>
                  {!slide.isVideo && (
                    <div
                      className={`d-flex image-container-social justify-content-center align-items-center ${
                        slide?.shadowOverlay ? 'shadowed-img' : ''
                      }`}
                      key={key}
                      style={
                        slide.imgURL
                          ? {
                              backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                              backgroundSize: 'cover',
                            }
                          : {}
                      }
                    >
                      {!slide.imgURL && <p>Image</p>}
                    </div>
                  )}
                  {slide?.isVideo && (
                    <div className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`} key={key}>
                      <div className='video-container-csc'>
                        <video
                          style={{
                            width: '90px',
                            height: '90px',
                            objectFit: 'fill',
                            position: 'relative',
                            top: 0,
                            left: 0,
                          }}
                          autoPlay
                          loop={slide?.loopPlayBack}
                          preload='auto'
                          src={slide?.videoURL}
                          muted
                        />
                        <div className='slide-title-csc'>{slide.videoURL ? '' : 'Video'}</div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
              {config?.viewAll?.isActive && (
                <div className='h-100'>
                  <div className='d-flex justify-content-center align-items-center view-all-social'>
                    <p>View All</p>
                  </div>
                </div>
              )}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  );
};

export default CarouselSocialComponentPreview;
